module.exports = __webpack_public_path__ + "static/media/Linda Carmona-Sanchez Headshot.b63551a9.jpeg";